import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { InstantSearchService } from '../../services/instant-search.service';
import { filter, map, Subscription } from 'rxjs';
import { InstantSearch, UiState, Widget } from 'instantsearch.js';
import connectRefinementList, { RefinementListConnectorParams } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import { AlgoliaRefinmentList } from '../../constants/algolia-refinement-list';
import { IRefinementListRenderOptions } from '../../models/algolia-refinement-render-options';
import { AlgoliaRefinement } from '../../enums/algolia-refinement';
import { IAlgoliaRefinementDescriptor } from '../../models/algolia-refinement-descriptor';
import connectClearRefinements from 'instantsearch.js/es/connectors/clear-refinements/connectClearRefinements';

@Component({
  selector: 'app-search-refinement-panel',
  standalone: false,
  templateUrl: './search-refinement-panel.component.html',
  styleUrl: './search-refinement-panel.component.scss'
})
export class SearchRefinementPanelComponent implements OnInit, OnDestroy {
readonly refinementDescriptors: IAlgoliaRefinementDescriptor[] = 
  AlgoliaRefinmentList.filter(i => i.id !== AlgoliaRefinement.EntityType).sort((a, b) => a.sortOrder - b.sortOrder);
readonly entityTypeRefinementDescriptor?: IAlgoliaRefinementDescriptor = AlgoliaRefinmentList.find(i => i.id === AlgoliaRefinement.EntityType);


  @Input() id: string = "facets-panel"


  subscriptions: Subscription = new Subscription();
  widgets: Widget[] = [];

  refinementRenderOptions: Map<AlgoliaRefinement, IRefinementListRenderOptions> = new Map();
  showRefinementPanel: boolean = false;
  canClearRefinements: boolean = false;
  clearRefinements: () => void = () => {}


  constructor(
    private _instantSearchService: InstantSearchService
  ) {}

  ngOnInit(): void {
    this.setupInstantSearchService();
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();

    if (this._instantSearchService?.instance && this.widgets.length > 0) {
      this._instantSearchService.instance.removeWidgets(this.widgets);
    }
  }

  setupInstantSearchService(): void {
    this.subscriptions.add(this._instantSearchService.instanceSubject$.pipe(
      filter((instance) => instance !== null),
      map((instance) => instance as InstantSearch<UiState, UiState>)
    ).subscribe({
      next: (instantSearchInstance: InstantSearch<UiState, UiState>) => {
        this.setupRefinements(instantSearchInstance);
        this.setupClearRefinements(instantSearchInstance);
      }
    }));
  }

  setupRefinements(instantSearchInstance: InstantSearch<UiState, UiState>) : void {

    for(const refinementDescriptor of AlgoliaRefinmentList) {
      const customRefinementList = connectRefinementList(
        (renderOptions: IRefinementListRenderOptions, 
          isFirstRender: boolean) => {

            if (isFirstRender) {

            }

            this.refinementRenderOptions.set(refinementDescriptor.id, renderOptions);
            this.showRefinementPanel = Array.from(this.refinementRenderOptions.values()).some(i => i.canRefine);
            console.log(`FacetPanel ${refinementDescriptor.name}:`, renderOptions)
        }
      );
      //const ss: RefinementListConnectorParams
      const refinementListWidget = customRefinementList({
        attribute: refinementDescriptor.name,
        operator:'or',
        showMore: true,
        showMoreLimit: 20,
        limit: 10
       } as RefinementListConnectorParams
      );

      instantSearchInstance.addWidgets([refinementListWidget]);
      this.widgets.push(refinementListWidget);
    }

  }

  setupClearRefinements(instantSearchInstance: InstantSearch<UiState, UiState>) : void {
    const customClearRefinement = connectClearRefinements(
      ({ canRefine, refine, widgetParams }, isFirstRender: boolean) => {
        if (isFirstRender) {

        }
        this.canClearRefinements = !canRefine;
        this.clearRefinements = refine;

      }
    );

    const clearRefinementsWidget = customClearRefinement({});
    instantSearchInstance.addWidgets([clearRefinementsWidget]);
    this.widgets.push(clearRefinementsWidget);
  }

  resetRefinements() {
    this.clearRefinements();
  }
}
